var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/romania") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/romania",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "romania",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.043,15.922 C317.309,5.633 287.314,0 256,0 C224.686,0 194.69,5.633 166.957,15.922 L144.696,255.999 L166.957,496.076 C194.689,506.368 224.685,512 256,512 C287.313,512 317.31,506.368 345.043,496.076 L367.303,256 L345.043,15.922 Z",
    id: "Path",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,256 C512,145.93 442.528,52.093 345.043,15.923 L345.043,496.079 C442.528,459.905 512,366.072 512,256 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,255.999 C0,366.072 69.472,459.905 166.956,496.078 L166.956,15.924 C69.472,52.094 0,145.928 0,255.999 Z",
    id: "Path",
    fill: "#0052B4"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRo);
export default __webpack_public_path__ + "static/media/RO.f1696b7d7aba5e6c79b8f2a2a4512928.svg";
export { ForwardRef as ReactComponent };